import axios from 'axios';
import {
  getNowTime,
  proofTime
} from '@/common/util/utils'
import encrypt from '@peiyou/xesencrypt/dist'
import { DC_APP_ID_SECREAT } from '@/common/util/config'

// 创建axios实例
const service = axios.create();

// request拦截器
service.interceptors.request.use(config => {
  config.baseURL = location.origin
  config.headers['timestamp'] = getNowTime()
  config.headers['algorithm'] = 'HmacSHA1'
  config.headers['accessid'] = DC_APP_ID_SECREAT.APP_ID
  config.headers['sign'] = encrypt.sign(config, DC_APP_ID_SECREAT.APP_SECREAT)
  return config;
}, error => {
  console.log(error);
  Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
  response => {
    // 校对当前时间
    if (response.headers.currentservertime) {
      proofTime(response.headers.currentservertime)
    }
    return response
  },
  error => {
    if (error.response && error.response.headers && error.response.headers.currentservertime) {
      proofTime(error.response.headers.currentservertime)
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/common/util/fetch.js